// Unit conversions between the @react-pdf/renderer styling (pt / px) used by the
// existing PDF templates and the units expected by the `docx` library.
//
// docx units:
// - font sizes are in HALF-points (so 10pt -> 20)
// - spacing / indentation / table widths (DXA) are in TWIPS (1pt = 20 twips)
// - colors are hex strings WITHOUT the leading '#'
//
// react-pdf treats a unitless number as a point and a `px` value at 72dpi, where
// 1px = 0.75pt. We mirror that so measurements line up with the PDF.

const PX_TO_PT = 0.75;

export function pxToPt( px ) {
    return px * PX_TO_PT;
}

export function ptToHalfPoints( pt ) {
    return Math.round( pt * 2 );
}

export function pxToHalfPoints( px ) {
    return ptToHalfPoints( pxToPt( px ) );
}

export function ptToTwips( pt ) {
    return Math.round( pt * 20 );
}

export function pxToTwips( px ) {
    return ptToTwips( pxToPt( px ) );
}

// Strip a leading '#' and normalise to upper-case for docx color props.
export function color( hex ) {
    return ( hex || '' ).replace( /^#/, '' ).toUpperCase();
}

// A4 page dimensions in twips (210mm x 297mm).
export const A4 = {
    width: 11906,
    height: 16838,
};
